import ConfirmModalContent from "@/lib/components/interactions/modals/ConfirmModalContent";
import { type LocaleDictionaryType } from "@/lib/main";
import useModal from "./useModal";

type PropsType = {
  title?: LocaleDictionaryType;
  message: LocaleDictionaryType;
  confirmText: LocaleDictionaryType;
  cancelText: LocaleDictionaryType;
  handleConfirm: () => void;
  handleCancel?: () => void;
  breakpoint?: number;
};

export default function useConfirmModal({
  title,
  message,
  confirmText,
  cancelText,
  handleConfirm,
  handleCancel,
  breakpoint,
}: PropsType) {
  const { modalRef, showModal, setShowModal, setContent, closeModal } =
    useModal();

  const handleConfirmClick = () => {
    handleConfirm();
    closeModal();
  };

  const handleCancelClick = () => {
    handleCancel?.();
    closeModal();
  };

  const handleOpenConfirmModalClick = () => {
    if (showModal) return;

    setContent(
      <ConfirmModalContent
        title={title}
        message={message}
        confirmText={confirmText}
        cancelText={cancelText}
        handleConfirmClick={handleConfirmClick}
        handleCancelClick={handleCancelClick}
        breakpoint={breakpoint}
      />,
    );

    setShowModal(true);
    modalRef.current?.focus();
  };

  return { handleOpenConfirmModalClick };
}
